<template>
  <div>

    <div class="p-grid">
      <div class="p-col">
        <div class="pure-form">
          <div class="p-d-flex form-item">
            <div class="flex-grow-1">
              <delegate-autocomplete @selected="delegateSelected"/>
              <br/>
              <input v-model="custom.delegate" type="text"  placeholder="Or enter custom speaker" />
            </div>
            <button class="pure-button pure-button-primary" :disabled="!custom.delegate || custom.delegate === ''" @click="useCustomDelegate">Use</button>
          </div>

          <div class="p-d-flex form-item">
            <div class="flex-grow-1">
              <delegate-autocomplete delegate-type="association" @selected="associationSelected"/>
              <br />
              <input v-model="custom.association" type="text" class="formulate-input"  placeholder="Or enter custom association" />
            </div>
            <button class="pure-button pure-button-primary" :disabled="!custom.association || custom.association === ''" @click="useCustomAssociation">Use</button>
          </div>

          <div class="p-d-flex form-item">
            <div class="flex-grow-1">
              <multiselect id="motion" label="name" track-by="id" placeholder="Type to search" open-direction="bottom" :options="motions" :multiple="false" :searchable="true" :loading="loadingMotions" :clear-on-select="false" :close-on-select="true" :options-limit="300" :limit="1" :max-height="300" :show-no-results="false" :hide-selected="false" :show-labels="false" @select="motionSelected">
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{ props.option.name }}</span>
                  </div>
                </template>
                <template slot="noOptions">
                  Start typing to see motions
                </template>
              </multiselect>
              <br />
              <input v-model="custom.motion" type="text" class="formulate-input" placeholder="Or enter custom motion name" />
           </div>
            <button class="pure-button pure-button-primary" :disabled="!custom.motion || custom.motion === ''" @click="useCustomMotion">Use</button>
          </div>
        </div>
      </div>
      <div class="p-col">

        <h3>Getting Ready</h3>

        <section>
          <h4>
            <span v-if="standby.delegate && standby.delegate !== ''">
              {{standby.delegate}} <button @click="clearDelegate" class="pure-button button-warning button-xsmall">x</button>
            </span>
            <span v-else>-</span>
          </h4>
          <h4>
            <span v-if="standby.association && standby.association !== ''">
              {{standby.association}} <button @click="clearAssociation" class="pure-button button-warning button-xsmall">x</button>
            </span>
            <span v-else>-</span>
          </h4>
          <h4>
            <span v-if="standby.motion && standby.motion !== ''">
              {{standby.motion}} <button @click="clearMotion" class="pure-button button-warning button-xsmall">x</button>
            </span>
            <span v-else>-</span>
          </h4>
          <button @click="setScreen" :disabled="settingScreen" class="pure-button button-success button-large">Set</button>

        </section>
      </div>
      <div class="p-col">

        <header class="p-d-flex p-ai-center">
          <span class="blob green"/>
          <div class="p-pl-3">
            <h3>On Screen Now</h3>
          </div>
        </header>

        <section v-if="onScreen">
          <h4>{{onScreen.delegate}}</h4>
          <h4>{{onScreen.association}}</h4>
          <h4>{{onScreen.motion}}</h4>
          <button @click="clear" :disabled="settingScreen" class="pure-button button-error button-large">Clear All</button>
          <button @click="clearDelegateAndAssociation" :disabled="settingScreen" class="pure-button button-error button-large">Clear Spk/Assc</button>

        </section>
      </div>
    </div>

    <speakers-toggle/>

    <section v-if="motion">
      <div class="p-grid motion">
        <div class="p-col">
          <h6>Motion</h6>
          <div class="p-d-flex p-ai-center">
            <button class="pure-button pure-button-primary" @click="useCurrentMotion">Use</button>
            <div class="p-pl-3">
              <h4>{{motion.name}}</h4>
            </div>
          </div>
        </div>
        <div class="p-col">
          <h6>Proposer</h6>
          <div class="p-d-flex p-ai-center">
            <button class="pure-button pure-button-primary" @click="useCurrentMotionProposer">Use</button>
            <div class="p-pl-3">
              <h4>{{motion.proposer.name}}, {{motion.proposer.associationName}}</h4>
            </div>
          </div>
        </div>
        <div class="p-col">
          <h6>Seconder</h6>
          <div class="p-d-flex p-ai-center">
            <button class="pure-button pure-button-primary" @click="useCurrentMotionSeconder">Use</button>
            <div class="p-pl-3">
              <h4>{{motion.seconder.name}}, {{motion.seconder.associationName}}</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="p-grid speakers">
        <div v-for="(opinion,i) in [motion.for, motion.against]" :key="`opinion-${i}`" class="p-col">
          <h4>
            <span v-if="i === 0">For</span>
            <span v-else>Against</span>
          </h4>
          <table class="pure-table pure-table-striped">
            <thead role="rowgroup" >
            <tr role="row">
              <th role="cell">Name</th>
              <th role="cell">Association</th>
              <th role="cell">Status</th>
              <th role="cell">Actions</th>
            </tr>
            </thead>
            <tbody role="rowgroup">
            <tr
              v-for="(speaker,i) in opinion"
              :key="`speaker-${i}`"
              :class="{'speaker-active' : speaker.status === 'Active'}"
            >
              <td>{{speaker.delegate.getName()}}</td>
              <td>{{speaker.delegate.associationName}}</td>
              <td>
                <div class="p-d-flex p-ai-center">
                  <span v-if="speaker.isActive()">
                    <span class="blob green"/>
                  </span>
                  <speaker-state-display :state="speaker.status"/>
                </div>
              </td>
              <td>
                <button class="pure-button pure-button-primary" @click="useDelegate(speaker.delegate)">Use</button>
              </td>
            </tr>
            <tr v-if="!opinion.length">
              <td colspan="4" class="empty-state">n/a</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <section v-if="motion.next">
        <h3>Next Motion</h3>
        <div class="p-grid motion">
          <div class="p-col">
            <h6>Motion</h6>
            <div class="p-d-flex p-ai-center">
              <button class="pure-button pure-button-primary" @click="useNextMotion">Use</button>
              <div class="p-pl-3">
                <h4>{{motion.next.name}}</h4>
              </div>
            </div>
          </div>
          <div class="p-col">
            <h6>Proposer</h6>
            <div class="p-d-flex p-ai-center">
              <button class="pure-button pure-button-primary" @click="useNextMotionProposer">Use</button>
              <div class="p-pl-3">
                <h4>{{motion.next.proposer.name}}, {{motion.next.proposer.associationName}}</h4>
              </div>
            </div>
          </div>
          <div class="p-col">
            <h6>Seconder</h6>
            <div class="p-d-flex p-ai-center">
              <button class="pure-button pure-button-primary" @click="useNextMotionSeconder">Use</button>
              <div class="p-pl-3">
                <h4>{{motion.next.seconder.name}}, {{motion.next.seconder.associationName}}</h4>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
    <div class="empty-state" v-else>
      No current motion
    </div>
  </div>
</template>

<script>
import HasCurrentMotion from '../../mixins/has-current-motion'
import cron from '../../mixins/cron'
import DelegateAutocomplete from '../delegates/DelegateAutocomplete.vue'
// import PropType from '../../enums/prop-type'
import SpeakerStateDisplay from '../speakers/SpeakerStateDisplay.vue'
import SpeakersToggle from '../speakers/SpeakersToggle.vue'
import Multiselect from 'vue-multiselect'
import eventBus from '../../services/event-bus'
export default {
  name: 'ScreenControlPanel',
  mixins: [
    HasCurrentMotion,
    cron
  ],
  components: {
    SpeakerStateDisplay,
    DelegateAutocomplete,
    SpeakersToggle,
    Multiselect
  },
  data: function () {
    return {
      custom: {
        delegate: null,
        association: null,
        motion: null
      },
      standby: {
        delegate: null,
        association: null,
        motion: null
      },
      motion2: null,
      loadingMotions: false,
      settingScreen: false
    }
  },
  computed: {
    onScreen () {
      return this.$store.getters['screens/current']
    },
    refreshRate () {
      return this.$store.getters['screens/refreshRate']
    },
    motions () {
      return this.$store.getters['motions/all']
    }
  },
  methods: {
    reload () {
      // console.log('reloading')
      // this.$store.dispatch('screens/load')
    },
    useCurrentMotion () {
      this.standby.motion = this.motion.nameFormatted()
    },
    useCurrentMotionProposer () {
      this.standby.delegate = this.motion.proposer.name
      this.standby.association = this.motion.proposer.associationName
    },
    useCurrentMotionSeconder () {
      this.standby.delegate = this.motion.seconder.name
      this.standby.association = this.motion.seconder.associationName
    },
    useNextMotion () {
      this.standby.motion = this.motion.next.nameFormatted()
    },
    useNextMotionProposer () {
      this.standby.delegate = this.motion.next.proposer.name
      this.standby.association = this.motion.next.proposer.associationName
    },
    useNextMotionSeconder () {
      this.standby.delegate = this.motion.next.seconder.name
      this.standby.association = this.motion.next.seconder.associationName
    },
    useCurrentMotionProp (type) {

    },
    useDelegate (delegate) {
      this.standby.delegate = delegate.getName()
      this.standby.association = delegate.associationName
    },
    useCustomDelegate () {
      this.standby.delegate = this.custom.delegate
    },
    useCustomAssociation () {
      this.standby.association = this.custom.association
    },
    useCustomMotion () {
      this.standby.motion = this.custom.motion
    },
    delegateSelected (delegate) {
      this.custom.delegate = delegate.getName()
      if (delegate.realPerson) {
        this.custom.association = delegate.associationName
      }
    },
    motionSelected (motion) {
      this.custom.motion = motion.name
    },
    associationSelected (delegate) {
      this.custom.association = delegate.name
    },
    clearDelegate () {
      this.standby.delegate = null
    },
    clearAssociation () {
      this.standby.association = null
    },
    clearMotion () {
      this.standby.motion = null
    },
    async setScreen () {
      this.settingScreen = true
      await this.$store.dispatch('screens/set', this.standby)
      this.settingScreen = false
    },
    async clear () {
      this.settingScreen = true
      await this.$store.dispatch('screens/clear')
      this.settingScreen = false
    },
    async clearDelegateAndAssociation () {
      this.settingScreen = true
      await this.$store.dispatch('screens/set', {
        delegate: null,
        association: null,
        motion: this.onScreen ? this.onScreen.motion : null
      })
      this.settingScreen = false
    }
  },
  async created () {
    eventBus.$on('screenUpdated', () => {
      this.settingScreen = false
    })
    this.$store.dispatch('screens/load')
    this.$store.dispatch('motions/load')
  },
  async mounted () {
    this.$cron.time('reload', this.refreshRate)
  },
  watch: {
    refreshRate () {
      this.$cron.time('reload', this.refreshRate)
    }
  },
  cron: [
    {
      time: 60000,
      method: 'reload'
    }
  ]
}
</script>

<style scoped>
.speakers, .speakers .p-chip {
  font-size: 0.8rem;
}
.speakers table {
  width: 100%;
}
.form-item {
  margin-bottom: 1rem;
}
.form-item input[type="text"] {
  width: 100%;
}
.motion h4 {
  margin: 0;
}
.motion h6 {
  margin: 0 0 0.5rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/screen/ScreenControlPanel.vue